import styled, { css } from 'styled-components';
import { themeGet } from 'styled-system';
import ArrowDownThinIcon from '../../icons/ArrowDownThin';
import Label from '../../Label';

export const borderColor = ({ invalid, valid, borderColor: customBorderColor }) => {
  if (valid) {
    return css`
      border-color: ${themeGet('colors.successGreen')};
    `;
  }
  if (invalid) {
    return css`
      border-color: ${themeGet('colors.digitalBrightRed.100')};
    `;
  }

  return css`
    border-color: ${customBorderColor ?? themeGet('colors.preciousStoneBlue.20')};
  `;
};

export const StyledSelect = styled.select`
  margin: 0;
  cursor: pointer;
  appearance: none;
  padding: 16px;
  padding-right: 30px;
  padding-top: ${({ placeholder, paddingTop, value }) =>
    paddingTop ? paddingTop : placeholder && value && value !== 'placeholder' ? `22px` : `15px`};
  padding-bottom: ${({ placeholder, paddingBottom, value }) =>
    paddingBottom ? paddingBottom : placeholder && value && value !== 'placeholder' ? `10px` : `14px`};
  border-radius: ${({ borderRadius }) => (borderRadius ? borderRadius : '10px')};
  background-color: ${({ backgroundColor }) =>
    backgroundColor ? themeGet('colors.' + backgroundColor) : themeGet('colors.snowMountainGrey.20')};
  width: 100%;
  border-width: ${({ borderWidth }) => (borderWidth ? borderWidth : '1px')};
  border-style: solid;
  font-size: ${({ fontSize }) => (fontSize ? themeGet('fontSizes.' + fontSize) : themeGet('fontSizes.1'))}px;
  color: ${({ color }) => (color ? themeGet('colors.' + color) : themeGet('colors.deepLakeBlue.100'))};
  font-family: ${themeGet('fonts.primary')};
  font-weight: ${({ fontWeight }) => (fontWeight ? fontWeight : themeGet('fontWeights.regular'))};
  line-height: 1.2;
  height: ${({ height }) => (height ? height : `50px`)};
  background-image: none !important;

  &:focus {
    outline: unset;
    border: none;
    box-shadow: 0 0 0 2px ${themeGet('colors.focusBlue')};
  }

  & + svg {
    ${({ isNewWidgetStyleActive }) =>
      isNewWidgetStyleActive &&
      css`
        fill: ${themeGet('colors.deepLakeBlue.100')};
        top: 35px;
        right: 13px;
        stroke-width: 2;
        path {
          stroke: black;
          stroke-width: 2;
        }
      `}
  }

  ${borderColor}
`;

export const StyledChevronDownIcon = styled(ArrowDownThinIcon)`
  pointer-events: none;
  display: flex;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 10px;
  fill: ${themeGet('colors.preciousStoneBlue.100')};
`;

export const StyledPlaceHolder = styled(Label)`
  top: 25px;
  transform: ${({ active, value }) =>
    active && value && value !== 'placeholder' ? `translateY(-15px) scale(.57)` : `translateY(-50%)`};
  left: ${themeGet('space.3')}px;
  color: ${props =>
    props.color && !props.active
      ? props.color
      : props.active
      ? themeGet('colors.preciousStoneBlue.100')
      : themeGet('colors.deepLakeBlue.100')};
  opacity: ${({ active, value }) => (active && value && value !== 'placeholder' ? `1` : `0`)};
  transition: all 0.1s ease-in-out 0s;
  font-size: ${themeGet('fontSizes.1')}px;
`;
